/**
 * 편집 화면 객체에서 문자열 값만 깊이 우선 수집해 금소법 키워드 검사용 텍스트를 만든다.
 * @param {unknown} root
 * @param {number} maxLen
 * @returns {string}
 */
export function collectMarketingStrings(root, maxLen = 4000) {
  const chunks = []
  const push = (s) => {
    const t = String(s || '').trim()
    if (!t) return
    chunks.push(t)
  }
  const approxLen = () => chunks.join('\n').length

  function walk(v) {
    if (approxLen() >= maxLen) return
    if (typeof v === 'string') {
      push(v)
    } else if (Array.isArray(v)) {
      for (const x of v) {
        walk(x)
        if (approxLen() >= maxLen) return
      }
    } else if (v && typeof v === 'object') {
      for (const x of Object.values(v)) {
        walk(x)
        if (approxLen() >= maxLen) return
      }
    }
  }

  walk(root)
  return chunks.join('\n').slice(0, maxLen)
}
